import React from 'react'

import * as S from './styles'

const UseTermContent = () => {
  return <>
    <S.Title>Termos de uso do Software Pet Anjo</S.Title>
    <S.Text>
      Este Termo de Uso estabelece as condições para a utilização do software (“SOFTWARE”) fornecido pela PET ANJO FRANQUEADORA LTDA., pessoa jurídica de direito privado, com sede na Rua Professora Helena Moura Lacerda, nº 140, andar 1, sala 02, Vila Hamburguesa, na cidade de São Paulo, Estado de São Paulo, CEP 05319-015, inscrita no CNPJ/ME sob o n° 45.585.966/0001-76 (“PET ANJO”), que será utilizado pelo franqueado (“FRANQUEADO”), que possuir uma relação de franquia pertencentes à rede franqueada PET ANJO.<br />
      <br />
      <span>1. Licença de Uso:</span><br />
      A PET ANJO concederá ao FRANQUEADO, enquanto existir a relação de franquia e com base nas condições existentes no presente instrumento e no contrato de franquia, uma licença não exclusiva, intransferível e limitada para utilizar o SOFTWARE, estritamente de acordo com os termos e condições estabelecidos neste documento.
      <br />
      A duração da licença de uso do SOFTWARE será especificada pela PET ANJO que se reserva o direito de alternância de SOFTWARE, conforme a necessidade. A utilização do SOFTWARE estará limitada ao período de vigência da relação de franquia, exceto se houver disposição em contrário.
      A PET ANJO se reserva o direito de monitorar o uso do SOFTWARE pelo FRANQUEADO para garantir conformidade com os termos desta licença.
      <br />
      <br />
      <span>2. Restrições de Uso:</span><br />
      O FRANQUEADO concorda em utilizar o SOFTWARE somente para os fins estabelecidos neste instrumento e no contrato de franquia com o objetivo de viabilizar o atendimento ao cliente final em unidade franqueada designada à clínica veterinária.
      <br />
      O FRANQUEADO concorda e se compromete a não copiar, reproduzir, distribuir, sublicenciar, vender ou explorar comercialmente o SOFTWARE de qualquer forma sem autorização prévia por escrito da PET ANJO.
      <br />
      A PET ANJO se reserva o direito de suspender ou rescindir a licença de uso do SOFTWARE em caso de violação dos termos e condições estabelecidos neste documento ou no contrato de franquia, sem prejuízo de outros direitos legais.
      <br />
      <br />
      <span>3. Propriedade Intelectual:</span><br />
      O SOFTWARE e todo o seu conteúdo, incluindo, mas não se limitando a códigos, interfaces, gráficos e documentos são protegidos por leis de propriedade intelectual e pertence exclusivamente à PET ANJO.<br />
      <br />
      <span>4. Responsabilidades do Franqueado:</span><br />
      O FRANQUEADO é responsável por garantir que o uso do SOFTWARE esteja em conformidade com todas as leis e regulamentos aplicáveis, bem como se responsabiliza pela utilização que deve ser somente aos fins estabelecidos neste instrumento e no contrato de franquia. Além disso, compromete-se a não realizar atividades que possam comprometer a integridade ou segurança do SOFTWARE.
      <br />
      <br />
      <span>5. Atualizações e Manutenção:</span>
      <br />
      A PET ANJO reserva-se o direito de fornecer atualizações, melhorias e correções de bugs para o SOFTWARE periodicamente. Sendo necessário, o FRANQUEADO concorda em instalar tais atualizações e manter o SOFTWARE atualizado, conforme instruções da PET ANJO.
      <br />
      <br />
      <span>6. Confidencialidade e Segurança:</span>
      <br />
      O FRANQUEADO concorda em manter em sigilo sobre todas as informações confidenciais relacionadas ao SOFTWARE e à PET ANJO, e em adotar medidas razoáveis de segurança para proteger o SOFTWARE contra qualquer acesso não autorizado ou uso indevido.
      <br />
      <br />
      <span>7. Disposições Gerais:</span>
      <br />
      Este Termo de Uso constitui o acordo entre as partes no que diz respeito ao uso do SOFTWARE. Este acordo será regido e interpretado de acordo com as leis brasileiras, excluindo-se os seus princípios de conflito de leis.
      Ao utilizar o SOFTWARE, o FRANQUEADO concorda em cumprir integralmente os termos e condições deste Termo de Uso. O não cumprimento de qualquer disposição deste documento pode resultar na rescisão imediata da licença de uso do SOFTWARE pela PET ANJO.
      Ao clicar em "Aceitar" ou simplesmente utilizar o SOFTWARE, o FRANQUEADO declara ter lido, compreendido e concordado com os termos e condições deste Termo de Uso.
      <br />
      <br />

    </S.Text>
  </>
}

export default UseTermContent
